import { Component } from '@angular/core';
import { EmployeeModuleMenuService } from '@app/modules/employees/services/employee-module-menu.service';
import { AuthService } from '@app/services';
import { ChangeRequestsIndexTable } from '@change-requests/services/tables/change-requests-table/change-requests-index.table';
import { IndexView } from '@common/views';

@Component({
    templateUrl: './change-request-index.template.html',
})
export class ChangeRequestIndexView extends IndexView {
    table: ChangeRequestsIndexTable;

    constructor(
        protected auth: AuthService,
        public employeeModuleMenuService: EmployeeModuleMenuService
    ) {
        super();
        this.table = new ChangeRequestsIndexTable(this.auth);
    }
}
